import Vue from 'vue'
import moment from "moment";

export default [

  {
    name: "fileType",
    title: 'Name',
    width: "60%",
    sortField: "fileType"
  },
  {
    name: "documentType",
    title: 'Type',
    width: "15%",
    sortField: "documentType.id",
    formatter(value) {
      return value.type;
    }
  },
  {
    name: "uploadedOn",
    title: 'Date',
    width: "15%",
    sortField: "uploadedOn",
    formatter(value) {
      if (value) {
        return moment(new Date(value)).utc().format("YYYY-MM-DD");
      }
    }
  },
  {
    name: "uploadedOn",
    title: 'Time',
    width: "15%",
    sortField: "uploadedOn",
    formatter(value) {
      if (value) {
        return moment(new Date(value)).utc().format("H:m:s");
      }
    }
  },
  {
    name: "sourceType",
    title: 'Source',
    width: "20%"
  },

]